import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  minimal: defineAsyncComponent(() => import("/app/layouts/minimal.vue").then(m => m.default || m))
}